import { useExtraProfileIcons } from './useExtraProfileIcons'
import { useExtraProfileFriend } from './useExtraProfileFriend'

export const useExtraProfile = () => {
  const isFriendIconsPending = useExtraProfileIcons()
  const isFriendProfilePending = useExtraProfileFriend()

  return isFriendIconsPending || isFriendProfilePending
}
